import React,{useState} from "react";
import Navbar from "../navbar/navbar";
import { api } from "../../services/api";
import { Link,Navigate,useParams } from 'react-router-dom'
import '../cadastro/cadastro.css';
import { vhostV1, vhostV2 } from "../funcoes";
import estados from "../../services/estados";
import pais from "../../services/pais";
import { useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import InputMask from 'react-input-mask';
import FooterBar from "../footer/footerBar";
import Modal from 'react-modal/lib/components/Modal';
import customizeScrollbar from "customsb";
import "./pedidos.css";
import { Toolbar } from "@mui/material";
import {
  Box,
  Paper,
  Container,
  Grid,
  Typography,
  Divider,
  Chip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Card,
  CardContent,
  Stack,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";



const ModalCadastroCliente = ({ isOpen, onRequestClose, setCodCadastro }) => {

    
         
        
    
        const tpc = "C";
        const id = -1;
        const {tag} = useParams();
     
         const [empresa,setEmpresa] = useState(0);
         const [razao,setRazao] = useState('');
         const [fantasia,setFantasia] = useState('');
         const [cnpj,setCnpj] = useState('');
         const [estadual,setEstadual] = useState('');
         const [inscMunicipal,setinscMunicipal] = useState('');
         const [cae,setCae] = useState('');
         const [endereco,setEndereco] = useState('');
         const [bairro,setBairro] = useState('');
         const [cep,setCep] = useState('');
         const [cidade,setCidade] = useState('');
         const [estado,setEstado] = useState('PE');
         const [telefone,setTelefone] = useState('');
         const [fax,setFax] = useState('');
         const [celular,setCelular] = useState('');
         const [contato,setContato] = useState('');
         const [endcob,setEndcob] = useState('');
         const [bairrocob,setBairrocob] = useState('');
         const [cepcob,setCepcob] = useState('');
         const [cidadecob,setCidadecob] = useState('');
         const [estadocob,setEstadocob] = useState('');
         const [obs,setObs] = useState('');
         const [atividade,setAtividade] = useState(0);
         const [correspondencia,setCorrespondencia] = useState('');
         const [tributacao,setTributacao] = useState('');
         const [comissao,setComissao] = useState(0);
         const [vendedor,setVendedor] = useState(0);
         const [registro,setRegistro] = useState('');
         const [deslocamento,setDeslocamento] = useState(0);
         const [ativo,setAtivo] = useState('T');
         const [multdistancia,setMultdistancia] = useState(0);
         const [multatividade,setMultatividade] = useState(0);
         const [cadastrado_por,setCadastrado_Por] = useState(99);
         const [cadastrado_em,setCadastrado_em] = useState('');
         const [alterado_por,setAlterado_Por] = useState(99);
         const [alterado_em,setAlterado_em] = useState('');
         const [area,setArea] = useState(0);
         const [limite,setLimite] = useState(0);
         const [ultimo_venc,setUltimo_venc] = useState('');
         const [atual_venc,setAtual_venc] = useState('');
         const [prazo,setPrazo] = useState(0);
         const [tipo_fatura,setTipo_fatura] = useState('');
         const [datanasc,setDatanasc] = useState('');
         const [dia_fatuta,setDia_fatura] = useState('');
         const [venc_cartao,setVenc_cartao] = useState('');
         const [cartao_proprio,setCartao_proprio] = useState('');
         const [senhacred,setSenhaCred] = useState('0000');
         const [nrend1,setNrend1] = useState('');
         const [nrend2,setNrende2] = useState('');
         const [e_mail,setE_mail] = useState('');
         const [cod_reg_trib,setCod_reg_tributatio] = useState('1');
         const [tipocad,setTipocad] = useState('');
         const [st_liminar,setSt_limiar] = useState('1');
         const [complementar,setComplementar] = useState('');
         const [tabela_preco,setTabela_preco] = useState(1);
         const [id_convenio,setId_convenio] = useState(0);
         const [nr_convenio,setNr_convennio] = useState("1");
         const [cod_ctardz,setCod_ctardz] = useState(0);
         const [dia_corte,setDiacorte] = useState(1);
         const [dia_vencimento,setDiaVencimento] = useState(1);
         const [protestar,setProtestar] = useState('0');
         const [dias_protestar,setDias_protestar] = useState(0);
         const [cpais,setCpais] = useState('1058');
         const [trilha1,setTrilha1] = useState('');
         const [trilha2,setTrilha2] = useState('');
         const [trilha3,setTrilha3] = useState('');
         const [credUtilizado, setCredUtilizado] = useState(0);
         const [credDisponivel, setCredDisponivel] = useState(0);
         const [msgErro, setmsgErro] = useState('');
         const [erroValidacao, setErrovalidacao] = useState(false);
         const [isEditing, setIsEditing] = useState(false);
         const [cadastro, setCadastro] = useState([]);
     
     
         const [buscaCidade,setBuscaCidade] = useState('');
         const [Cidades,setCidades] = useState([]);
         const [sucesso,setSucesso] = useState('');
         const [mensagem,setMensagem]= useState('');
         const [showPassword, setShowPassword] = useState(false);
         const [showModal, setShowModal] = useState(false); 
         const [openCidadeModal, setOpenCidadeModal] = useState(false);


     document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável
          var inputs = document.getElementsByTagName('input');
           for (var i = 0; i < inputs.length; i++) {
            if (inputs[i] === document.activeElement && i < inputs.length - 1) {
              inputs[i+1].focus();
              break;
            }
          }
        }
      });
    
      function validaCpfCnpj(val) {
        // Verifica se 'val' é uma string e não está vazia
        if (typeof val !== 'string' || val.trim() === '') {
            setmsgErro('Digite um CPF ou CNPJ');
            setErrovalidacao(true);
            return false;
        }
    
        // Remove caracteres não numéricos
        val = val.replace(/\D/g, '');
        console.log(val);
    
        if (cadastro.some(cadastros => cadastros.CNPJ === val)) {
          setmsgErro('CPF/CNPJ já cadastrado');
          setErrovalidacao(true);
          return false;
        } 
        
    
        if (val.length === 11) { // CPF
            let cpf = val.split('');
            let v1 = 0, v2 = 0, aux = false;
    
            for (let i = 1; cpf.length > i; i++) {
                if (cpf[i - 1] !== cpf[i]) aux = true;
            }
    
            if (!aux) {
                setmsgErro('Digite um CPF válido');
                setErrovalidacao(true);
                return false; 
            }
    
            for (let i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
                v1 += cpf[i] * p; 
            } 
    
            v1 = (v1 * 10) % 11;
            if (v1 === 10) v1 = 0;
    
            if (v1 !== Number(cpf[9])) {
                setmsgErro('Digite um CPF válido');
                setErrovalidacao(true);
                return false; 
            }
    
            for (let i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
                v2 += cpf[i] * p; 
            }
    
            v2 = (v2 * 10) % 11;
            if (v2 === 10) v2 = 0;
    
            return v2 === Number(cpf[10]); 
        } 
        else if (val.length === 14) { // CNPJ
            let cnpj = val.split('');
            let v1 = 0, v2 = 0, aux = false;
    
            for (let i = 1; cnpj.length > i; i++) { 
                if (cnpj[i - 1] !== cnpj[i]) aux = true; 
            } 
    
            if (!aux) {  
                setmsgErro('Digite um CNPJ válido');
                setErrovalidacao(true);
                return false; 
            }
    
            for (let i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
                if (p1 >= 2) v1 += cnpj[i] * p1;  
                else v1 += cnpj[i] * p2;  
            } 
    
            v1 = v1 % 11;
            if (v1 < 2) v1 = 0; 
            else v1 = 11 - v1; 
    
            if (v1 !== Number(cnpj[12])) {  
                setmsgErro('Digite um CNPJ válido');
                setErrovalidacao(true);
                return false; 
            } 
    
            for (let i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) { 
                if (p1 >= 2) v2 += cnpj[i] * p1;  
                else v2 += cnpj[i] * p2; 
            }
    
            v2 = v2 % 11; 
            if (v2 < 2) v2 = 0;
            else v2 = 11 - v2; 
    
            return v2 === Number(cnpj[13]);   
        } 
        setmsgErro('Digite um CPF ou CNPJ válido');
        setErrovalidacao(true);
        return false;
    }
    
    
      function limpaCpf(val){
        val = val.replace(/\D/g, '');
        return val
      }
    

        let config = {
          headers: {
            'Authorization': localStorage.getItem("token")
          }
        }

        let config2 = {
          headers: {
            'Authorization': localStorage.getItem("token2")
          }
        }
        
        const togglePasswordVisibility = () => {
          setShowPassword(!showPassword);
      };
       
      
       async function buscarEnderecoPorCep(cepParam) {
    const cepLimpo = cepParam.replace(/\D/g, "");

    if (!cepLimpo) {
      setmsgErro("CEP inválido");
      setErrovalidacao(true);
      return;
    }

    if (cepLimpo.length !== 8) {
      setmsgErro("CEP deve conter 8 dígitos");
      setErrovalidacao(true);
      return;
    }

    try {
      const url = `https://viacep.com.br/ws/${cepLimpo}/json/`;

      const response = await fetch(url);

      const data = await response.json();

      console.log(data);

      if (data.erro) {
        setmsgErro("CEP informado não foi encontrado ou não é válido");
        setErrovalidacao(true);
        return;
      }

      if (response.status === 200) {
        if (data.localidade) {
          setCidade(data.localidade);
        }

        if (data.logradouro) {
          setEndereco(data.logradouro);
        }

        if (data.bairro) {
          setBairro(data.bairro);
        }

        if (data.uf) {
          setEstado(data.uf);
        }
      }
    } catch (error) {
      console.error(error);

      setmsgErro("Erro ao buscar CEP");
      setErrovalidacao(true);
    }
  }
      
        useEffect(function(){
      
          api.post(vhostV1('webcash/cadastro'), {
             loja: localStorage.getItem('loja'),
             empresa: 0,
             pagina: 1,
             regPag: 1000,
             tipo:'%',
             busca: ''
           },config)
           .then(function (response) {
             
             setCadastro(response.data.dados);
             console.log(response.data.dados);
             
             
                                                 
                      
           })
           .catch(function (error) {
            
             console.log(error);
             
      
                     
           });
      
           
       },[])
      
       
      
      
      
      
        function listaCidades(e){
          e.preventDefault();
             
          api.post(vhostV2('webcash/cidade'), {
              loja: localStorage.getItem('loja'),
              empresa: 0,
              sigla: estado,
              busca:buscaCidade
            },config2)
            .then(function (response) {
              if(response.data.dados === undefined){
                   setmsgErro('Cidade não encontrada')
                   setErrovalidacao(true)
      
              }else{
                setCidades(response.data.dados);  
                console.log(response.data.dados);
              }
                                                
                       
            })
            .catch(function (error) {
             
              console.log(error);
      
                      
            });
          }
      
      
          function escolheCidade(e){
            //console(e.substring(0,7));
            setCidade(e.substring(8,60));          
                           
          }
      
          //busca cadastro
          
          useEffect(function(){
             
            api.post(vhostV2('webcash/cadastro/'+id), {
                loja: localStorage.getItem('loja'),
                empresa: 0        
              },config2)
              .then(function (response) {
                  console.log(response);
                  setTipocad(response.data.dados.TIPOCAD)
                  setRazao(response.data.dados.RAZAO);
                  setFantasia(response.data.dados.FANTASIA);
                  setCnpj(response.data.dados.CNPJ);
                  setEstadual(response.data.dados.ESTADUAL);
                  setCae(response.data.dados.CAE);
                  setinscMunicipal(response.data.dados.MUNICIPAL);
                  setTelefone(response.data.dados.TELEFONE);
                  setCelular(response.data.dados.CELULAR);
                  setE_mail(response.data.dados.E_MAIL);
                  setObs(response.data.dados.OBS);
                  setCpais(response.data.dados.PAIS);
                  setCep(response.data.dados.CEP);
                  setEndereco(response.data.dados.ENDERECO);
                  setBairro(response.data.dados.BAIRRO);
                  setEstado(response.data.dados.ESTADO);
                  setCidade(response.data.dados.CIDADE);
                  setLimite(response.data.dados.LIMITE);
                  setTipo_fatura(response.data.dados.TIPO_FATURA);
                  setVenc_cartao(response.data.dados.DIA_VENCIMENTO);
                  setDiacorte(response.data.dados.DIA_CORTE);
                  setSenhaCred(response.data.dados.SENHACRED);   
                  setCpais(response.data.dados.CPAIS);   
                  setNrend1(response.data.dados.NREND1);   
                  setComplementar(response.data.dados.COMPLEMENTAR);   
                  if(response.data.result === 1){
                    setIsEditing(true);
                  }
      
                  
                         
        
                }                               
              )
              .catch(function (error) {
                console.log(error);
                        
              });
                   
          },[])
        
      
        
          useEffect(() => {
            // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
            customizeScrollbar({
              scrollbarWidth: "10px",
              trackBackground: "#333",
              thumbBackground:
                "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
              thumbBorderRadius: "10px",
            });
          }, []);
          
          
      
      
        function salvaPessoa(e){
          e.preventDefault();
      
         
          
          
         
            
             const jsonPessoa = {};
            
             
              jsonPessoa.loja=Number(localStorage.getItem('loja'));
        jsonPessoa.COD_CADASTRO=Number(id);        
        jsonPessoa.EMPRESA=0;
        jsonPessoa.RAZAO=razao.toLocaleUpperCase();
        jsonPessoa.FANTASIA=fantasia;
        jsonPessoa.CNPJ=limpaCpf(cnpj);
        jsonPessoa.TIPO=tpc;
        jsonPessoa.ESTADUAL=estadual;        
        jsonPessoa.MUNICIPAL=inscMunicipal;
        jsonPessoa.CAE=String(cae);
        jsonPessoa.ENDERECO=endereco;
        jsonPessoa.BAIRRO=bairro;
        jsonPessoa.CEP=cep;
        jsonPessoa.CIDADE=cidade;
        jsonPessoa.ESTADO=estado;
        jsonPessoa.TELEFONE=telefone;
        jsonPessoa.FAX=fax;
        jsonPessoa.CELULAR=celular;
        jsonPessoa.CONTATO=contato;
        jsonPessoa.ENDCOB=endcob;
        jsonPessoa.BAIRROCOB=bairrocob;
        jsonPessoa.CEPCOB=cepcob;
        jsonPessoa.CIDADECOB=cidadecob;
        jsonPessoa.ESTADOCOB=estadocob;
        jsonPessoa.OBS=obs;
        jsonPessoa.ATIVIDADE=atividade;
        jsonPessoa.CORRESPONDENCIA=correspondencia;
        jsonPessoa.TRIBUTACAO=tributacao;
        jsonPessoa.COMISSAO=comissao;
        jsonPessoa.VENDEDOR=vendedor;
        jsonPessoa.REGISTRO=registro;
        jsonPessoa.DESLOCAMENTO=deslocamento;
        jsonPessoa.ATIVO=ativo;
        jsonPessoa.MULTDISTANCIA=multdistancia;
        jsonPessoa.MULTATIVIDADE=multdistancia;
        jsonPessoa.CADASTRADO_POR=cadastrado_por;
        jsonPessoa.CADASTRADO_EM=cadastrado_em;
        jsonPessoa.ALTERADO_POR=alterado_por;
        jsonPessoa.ALTERADO_EM=alterado_em;
        jsonPessoa.AREA=String(area);
        jsonPessoa.LIMITE=Number(limite);
        jsonPessoa.ULTIMO_VENC=ultimo_venc;
        jsonPessoa.ATUAL_VENC=atual_venc;
        jsonPessoa.PRAZO=prazo;
        jsonPessoa.TIPO_FATURA=tipo_fatura;
        jsonPessoa.DATANASC=datanasc;
        jsonPessoa.DIA_FATUTA=dia_fatuta;
        jsonPessoa.VENC_CARTAO=String(venc_cartao);
        jsonPessoa.CARTAO_PROPRIO=cartao_proprio;
        jsonPessoa.SENHACRED=senhacred;
        jsonPessoa.NREND1=nrend1;
        jsonPessoa.NREND2=nrend2;
        jsonPessoa.E_MAIL=e_mail;
        jsonPessoa.COD_REG_TRIB=cod_reg_trib;
        jsonPessoa.TIPOCAD=String(tipocad);
        jsonPessoa.ST_LIMINAR=st_liminar;
        jsonPessoa.COMPLEMENTAR=complementar;
        jsonPessoa.TABELA_PRECO=tabela_preco;
        jsonPessoa.ID_CONVENIO=id_convenio;
        jsonPessoa.NR_CONVENIO=nr_convenio;
        jsonPessoa.COD_CTARDZ=cod_ctardz;
        jsonPessoa.DIA_CORTE=Number(dia_corte);
        jsonPessoa.DIA_VENCIMENTO=Number(dia_vencimento);
        jsonPessoa.PROTESTAR=protestar;
        jsonPessoa.DIAS_PROTESTAR=dias_protestar;
        jsonPessoa.CPAIS=cpais;
        jsonPessoa.TRILHA1=trilha1;
        jsonPessoa.TRILHA2=trilha2;
        jsonPessoa.TRILHA3=trilha3;

              
      
              console.log(jsonPessoa);
      
              if(razao === undefined || razao.length === 0){
                setmsgErro('Nome nao pode estar vazio')
                setErrovalidacao(true)
             }else if(cnpj === undefined || cnpj.length === 0 ){
              
                 setmsgErro('CPF/CNPJ não pode estar vazio')
                 setErrovalidacao(true)
               
               
             }else if (Number(id) === -1 && cadastro.some(cadastros => cadastros.CNPJ === cnpj)) {
              setmsgErro('CPF/CNPJ já cadastrado');
              setErrovalidacao(true);
            }else if(tipocad === undefined || tipocad.length === 0){
              setmsgErro('Selecione o tipo de cadastro')
              setErrovalidacao(true)
            } else{

             
      
              api.post(vhostV1('webcash/cadastro/inserir'),
                  jsonPessoa
              ,config)
              .then(function(response){
                if(response.data.result === 1){
                setCodCadastro(response.data.codigoCadastro);
                setMensagem('');
                  setSucesso('S');
              }
                console.log(response)
                  
                  
                  
              }).catch((erro) =>{
                  
                  console.log(erro);
                  setmsgErro(erro);
                  setErrovalidacao(true);
                  setSucesso('N');
              });
      
             }
           }
      
           const handleChangeTipoCad = (e) => {
            setTipocad(e.target.value);
            setCnpj('');
            setRazao('');
            setFantasia('');
        };
        
        const handleCnpjChange = (e) => {
          const value = e.target.value;
          setCnpj(value);
      };
      
      const handleCpfChange = (e) => {
          const value = e.target.value;
          setCnpj(value);
      };

      function handleRazaoChange(e) {
  const maxLength = 60;
  const value = e.target.value;


  if (value.length <= maxLength) {
    setRazao(value);
  }
}

function handleFantasiaChange(e) {
  const maxLength = 40;
  const value = e.target.value;


  if (value.length <= maxLength) {
    setFantasia(value);
  }
}

async function consultarCNPJ(e) {
    e.preventDefault();

    try {
      const cnpjLimpo = cnpj.replace(/\D/g, "");

      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`,
      );

      const data = await response.json();

      console.log(data);

      if (data.message && data.message.includes("não encontrado")) {
        setmsgErro("CNPJ não encontrado");
        setErrovalidacao(true);

        return;
      }

      setErrovalidacao(false);

      if (data.cnae_fiscal) {
        setCae(data.cnae_fiscal);
      }

      if (data.razao_social) {
        setRazao(data.razao_social);
      }

      if (data.nome_fantasia) {
        setFantasia(data.nome_fantasia);
      }

      if (data.complemento) {
        setComplementar(data.complemento);
      }

      if (data.numero) {
        setNrend1(data.numero);
      }

      if (data.email) {
        setE_mail(data.email);
      }

      if (data.cep) {
        setCep(data.cep);

        // sincroniza com busca de endereço
        await buscarEnderecoPorCep(data.cep);
      }
    } catch (error) {
      console.error("Erro ao consultar CNPJ:", error);

      setmsgErro("Erro ao consultar CNPJ");
      setErrovalidacao(true);
    }
  }

  const formataCPF = (valor) => {
  return valor
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

const formataCNPJ = (valor) => {
  return valor
    .replace(/\D/g, "")
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

      return (<Dialog
  open={isOpen}
  onClose={onRequestClose}
  maxWidth={false}
  fullWidth
  PaperProps={{
    sx: {
      width: "95vw",
      height: "95vh",
      maxWidth: "none"
    }
  }}
>
  <Box
  sx={{
    p: 3,
    height: "100%",
    overflowY: "auto"
  }}
>
  <Box sx={{ p: 3 }}>

  <Typography
    variant="h5"
    gutterBottom
  >
    Cadastro de Cliente
  </Typography>

  <Grid
    container
    spacing={2}
    sx={{ mb: 2 }}
  >
    <Grid size={{ xs: 12, md: 3 }}>
      <FormControl fullWidth>
        <InputLabel>
          Tipo
        </InputLabel>

        <Select
          value={tipocad}
          label="Tipo"
          onChange={handleChangeTipoCad}
        >
          <MenuItem value="">
            Selecione o tipo de cadastro
          </MenuItem>

          <MenuItem value={1}>
            Jurídica
          </MenuItem>

          <MenuItem value={0}>
            Física
          </MenuItem>
        </Select>
      </FormControl>
    </Grid>
  </Grid>

  <Divider sx={{ mb: 3 }} />

  <Box component="form">

    {Number(tipocad) !== 0 ? (

      <Grid
        container
        spacing={2}
      >

        <Grid size={12}>
          <TextField
            fullWidth
            label="RAZÃO"
            value={razao}
            onChange={handleRazaoChange}
            autoComplete="off"
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            label="FANTASIA"
            value={fantasia}
            onChange={handleFantasiaChange}
            autoComplete="off"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="CNPJ"
            placeholder="Digite seu CNPJ"
            value={cnpj}
            onChange={(e) => {
              const valorFormatado =
                formataCNPJ(
                  e.target.value
                );

              handleCnpjChange({
                target: {
                  value:
                    valorFormatado
                }
              });
            }}
            onBlur={(e) =>
              validaCpfCnpj(
                e.target.value
              )
            }
            InputProps={{
                  endAdornment: (
                    <IconButton
                      color="primary"
                      onClick={consultarCNPJ}
                      edge="end"
                    >
                      <SearchIcon />
                    </IconButton>
                  )
                }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="INSC EST"
            value={estadual}
            onChange={(e) =>
              setEstadual(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="C.N.A.E"
            value={cae}
            onChange={(e) =>
              setCae(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="INSC MUNICIPAL"
            value={inscMunicipal}
            onChange={(e) =>
              setinscMunicipal(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="TELEFONE"
            value={telefone}
            onChange={(e) =>
              setTelefone(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="Celular / Whatsapp"
            value={celular}
            onChange={(e) =>
              setCelular(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label="EMAIL"
            value={e_mail}
            onChange={(e) =>
              setE_mail(
                e.target.value
              )
            }
          />
        </Grid>

      </Grid>

    ) : (

      <Grid
        container
        spacing={2}
      >

        <Grid size={12}>
          <TextField
            fullWidth
            label="NOME"
            value={razao}
            onChange={(e) =>
              setRazao(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="CPF"
            placeholder="Digite seu CPF"
            value={cnpj}
            onChange={(e) => {

              const valorFormatado =
                formataCPF(
                  e.target.value
                );

              handleCpfChange({
                target: {
                  value:
                    valorFormatado
                }
              });

            }}
            onBlur={(e) =>
              validaCpfCnpj(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="RG"
            value={estadual}
            onChange={(e) =>
              setEstadual(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="TELEFONE"
            value={telefone}
            onChange={(e) =>
              setTelefone(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <TextField
            fullWidth
            label="Celular / Whatsapp"
            value={celular}
            onChange={(e) =>
              setCelular(
                e.target.value
              )
            }
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            label="EMAIL"
            value={e_mail}
            onChange={(e) =>
              setE_mail(
                e.target.value
              )
            }
          />
        </Grid>

      </Grid>

    )}

    <Grid
      container
      spacing={2}
      sx={{ mt: 2 }}
    >
      <Grid size={12}>
        <TextField
          fullWidth
          label="OBS"
          value={obs}
          onChange={(e) =>
            setObs(
              e.target.value
            )
          }
        />
      </Grid>
    </Grid>  
    </Box>              

<Card sx={{ mt: 3 }}>
  <CardContent>

    <Typography variant="h6" gutterBottom>
      Endereço
    </Typography>

    <Divider sx={{ mb: 3 }} />

    <Grid container spacing={2}>

      <Grid size={{ xs: 12, md: 3 }}>
        <FormControl fullWidth>
          <InputLabel>País</InputLabel>

          <Select
            value={cpais}
            label="País"
            onChange={(e) => setCpais(e.target.value)}
          >
            {pais.map((p) => (
              <MenuItem
                key={p.codigo}
                value={p.codigo}
              >
                {p.nome}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="CEP"
          value={cep}
          onChange={(e) => setCep(e.target.value)}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={buscarEnderecoPorCep}
              >
                <SearchIcon />
              </IconButton>
            )
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Endereço"
          value={endereco}
          onChange={(e) =>
            setEndereco(e.target.value)
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 2 }}>
        <TextField
          fullWidth
          label="Número"
          value={nrend1}
          onChange={(e) =>
            setNrend1(e.target.value)
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 10 }}>
        <TextField
          fullWidth
          label="Complemento"
          value={complementar}
          onChange={(e) =>
            setComplementar(e.target.value)
          }
          inputProps={{
    maxLength: 40
  }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          label="Bairro"
          value={bairro}
          onChange={(e) =>
            setBairro(e.target.value)
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 2 }}>
        <FormControl fullWidth>
          <InputLabel>Estado</InputLabel>

          <Select
            value={estado}
            label="Estado"
            onChange={(e) =>
              setEstado(e.target.value)
            }
          >
            {estados.map((uf, i) => (
              <MenuItem
                key={i}
                value={uf.sigla}
              >
                {uf.sigla}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Cidade"
          value={cidade}
          disabled
          InputProps={{
            endAdornment: (
              <Button
                variant="outlined"
                onClick={() =>
                  setOpenCidadeModal(true)
                }
              >
                Pesquisar
              </Button>
            )
          }}
        />
      </Grid>

    </Grid>

  </CardContent>
</Card>

<Dialog
  open={openCidadeModal}
  onClose={() =>
    setOpenCidadeModal(false)
  }
  maxWidth="md"
  fullWidth
>
  <DialogTitle>
    Pesquisa de Cidade
  </DialogTitle>

  <DialogContent>

    <Box sx={{ mt: 1, mb: 2 }}>
      <Stack
        direction={{
          xs: "column",
          sm: "row"
        }}
        spacing={1}
      >
        <TextField
          fullWidth
          label="Digite sua pesquisa"
          value={buscaCidade}
          onChange={(e) =>
            setBuscaCidade(
              e.target.value
            )
          }
        />

        <Button
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={listaCidades}
          sx={{
            minWidth: {
              xs: "100%",
              sm: 130
            }
          }}
        >
          Pesquisar
        </Button>
      </Stack>
    </Box>

    <TableContainer component={Paper}>
      <Table size="small">

        <TableHead>
          <TableRow>
            <TableCell width={120}>
              Código
            </TableCell>

            <TableCell>
              Cidade
            </TableCell>

            <TableCell
              width={100}
              align="center"
            >
              Ação
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>

          {Cidades.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={3}
                align="center"
              >
                Nenhuma cidade encontrada
              </TableCell>
            </TableRow>
          ) : (
            Cidades.map((city) => (
              <TableRow
                key={city.COD_MUN}
                hover
              >
                <TableCell>
                  {city.COD_MUN}
                </TableCell>

                <TableCell>
                  {city.NOME_MUNICIPIO}
                </TableCell>

                <TableCell align="center">
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {

                      escolheCidade(
                        city.COD_MUN +
                        "-" +
                        city.NOME_MUNICIPIO
                      );

                      setOpenCidadeModal(
                        false
                      );
                    }}
                  >
                    Selecionar
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}

        </TableBody>

      </Table>
    </TableContainer>

  </DialogContent>

  <DialogActions>
    <Button
      onClick={() =>
        setOpenCidadeModal(false)
      }
    >
      Fechar
    </Button>
  </DialogActions>
</Dialog>
                    
                  <Card sx={{ mt: 3 }}>
  <CardContent>

    <Typography
      variant="h6"
      gutterBottom
    >
      Financeiro
    </Typography>

    <Divider sx={{ mb: 3 }} />

    <Grid container spacing={2}>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Limite de Crédito"
          value={limite}
          onChange={(e) =>
            setLimite(e.target.value)
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <FormControl fullWidth>
          <InputLabel>
            Tipo Fatura
          </InputLabel>

          <Select
            value={tipo_fatura}
            label="Tipo Fatura"
            onChange={(e) =>
              setTipo_fatura(
                e.target.value
              )
            }
          >
            <MenuItem value="FATURA">
              FATURA
            </MenuItem>

            <MenuItem value="VENCIMENTO">
              VENCIMENTO
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Dia Vencimento"
          value={dia_vencimento}
          onChange={(e) =>
            setDiaVencimento(
              e.target.value
            )
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Dia Corte"
          value={dia_corte}
          onChange={(e) =>
            setDiacorte(
              e.target.value
            )
          }
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Senha"
          type={
            showPassword
              ? "text"
              : "password"
          }
          value={senhacred}
          onChange={(e) =>
            setSenhaCred(
              e.target.value
            )
          }
          InputProps={{
            endAdornment: (
              <IconButton
                edge="end"
                onClick={() =>
                  setShowPassword(
                    !showPassword
                  )
                }
              >
                {showPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </IconButton>
            )
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Crédito Utilizado"
          value={credUtilizado}
          InputProps={{
            readOnly: true
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Crédito Disponível"
          value={credDisponivel}
          InputProps={{
            readOnly: true
          }}
        />
      </Grid>

    </Grid>

  </CardContent>
</Card>

{/* ========================= BOTÕES ========================== */}

<Box
  sx={{
    mt: 3,
    pt: 2,
    borderTop: "1px solid",
    borderColor: "divider",
    display: "flex",
    justifyContent: "flex-end",
    gap: 1.5
  }}
>
  <Button
    variant="outlined"
    onClick={onRequestClose}
  >
    Desistir
  </Button>

  <Button
    variant="contained"
    onClick={salvaPessoa}
  >
    Salvar
  </Button>
</Box>


{/* ========================= ERRO ========================== */}

{mensagem.length > 0 && (
  <Alert
    severity="error"
    sx={{ mt: 2 }}
  >
    {mensagem}
  </Alert>
)}

{sucesso === "S"
  ? onRequestClose()
  : null}

</Box>


{/* ========================= VALIDAÇÃO ========================== */}

<Dialog
  open={erroValidacao}
  onClose={() =>
    setErrovalidacao(false)
  }
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>
    Erro
  </DialogTitle>

  <DialogContent>
    <Typography>
      {msgErro}
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      variant="contained"
      color="error"
      onClick={() =>
        setErrovalidacao(false)
      }
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
 </Box>
          
     
     </Dialog> );
}

export default ModalCadastroCliente;